const THREE_DECIMAL_CURRENCIES = ["TND", "KWD", "BHD", "OMR", "JOD", "IQD", "LYD"];

export const currencyDecimals = (currency) =>
  THREE_DECIMAL_CURRENCIES.includes(String(currency || "").toUpperCase()) ? 3 : 2;

const formatters = new Map();

const getFormatter = (decimals) => {
  if (!formatters.has(decimals)) {
    formatters.set(
      decimals,
      new Intl.NumberFormat("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })
    );
  }
  return formatters.get(decimals);
};

/** Formats an amount with the correct number of decimals for its currency. */
export const formatAmount = (value, currency) => {
  if (value === null || value === undefined || value === "") return "—";
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  return getFormatter(currencyDecimals(currency)).format(number);
};

export const formatMoney = (value, currency) => {
  const amount = formatAmount(value, currency);
  if (amount === "—") return amount;
  return currency ? `${amount} ${String(currency).toUpperCase()}` : amount;
};

export default formatMoney;
